import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Divider,
  CircularProgress,
  CardActionArea,
} from "@mui/material";
import axios from "axios";
import Footer from '../components/SFooter';
import Header from '../components/Header';
import cartService from '../service/cartService';
import { useAuth } from '../context/AuthContext';
import orderService from '../service/orderService';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';
import { useCart } from '../context/CartContext';
import axiosInstance from '../common/axios';

//payment method 
//coupon call 
const convenienceFees = {
  UPI: 10,
  Bank: 25,
  "Net Banking": 15,
  "Cash on Delivery": 0,
};

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const Payment = () => {
  const [cart, setCart] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [coupon, setCoupon] = useState("");
  const [discount, setDiscount] = useState(0);
  const [loading, setLoading] = useState(true);
    const { user } = useAuth();
  const navigate = useNavigate();
    const { t } = useTranslation();
    const { loadCartFromServer } = useCart();
  
  // Fetch cart + totals from backend
  useEffect(() => {

    fetchCart();
  }, []);

      const fetchCart = async () => {
      try {
        
        
        const res = await cartService.getUserCart(user.userId);
        setCart(res.data);
     // setCart(catsss);
        setLoading(false);
      } catch (err) {
        console.error("Failed to load payment data", err);
        setLoading(false);
      }
    };
  
  const handleApplyCoupon = async () =>  {
    try{
         const payload = {
        code: coupon,
        cartId: cart.cartId
      };
        await axios.post(`${backendUrl}/api/coupons/apply-coupon`, payload);
      
      fetchCart();
      alert("Coupon applied successfully");
} catch (err) {
  alert(err.response.data.message);
}
  };
  

  
    const onChangeAddress = async () => {
   navigate('/checkout');
  };

  
  const handlePay = async () => {
    try {
      
        const payload = {
        userId: user.userId,
        cartId: cart.cartId,
        paymentMethod
        //coupon: discount > 0 ? coupon : null,
      };
      
      // 1. Call backend /pay
      const payRes = await orderService.payOrder(payload);
      
      const {
        orderId,
        razorpayOrderId,
        amount,
        currency,
        key
      } = payRes.data;

      // 2. Razorpay options
      const options = {
        key,
        amount,
        currency,
        order_id: razorpayOrderId,
        name: "Foodsakz",
        description: "Order Payment",
        handler: async function (response) {

          // 3. Verify payment
          const verifyRes = await axios.post(
            `${backendUrl}/api/payments/verify`,
            {
              orderId: orderId,
               cartId: cart.cartId,
              razorpayOrderId: response.razorpay_order_id,
              razorpayPaymentId: response.razorpay_payment_id,
              razorpaySignature: response.razorpay_signature
            }
          );
          
          if (verifyRes.data.success) {
            
             loadCartFromServer();
              // Navigate to the result page with data
              navigate(`/paymentresult`, { 
                state: { 
                  status: "success", 
                  invoiceId: verifyRes.data.invoiceId 
                } 
              });
            } else {
              navigate(`/paymentresult`, { state: { status: "failure" } });
            }

        /*  if (verifyRes.data.success) {
            alert("Payment Successful 🎉");

            // 4. Download Invoice
            window.location.href =
              `http://localhost:8080/api/payment/invoice/${verifyRes.data.orderId}`;
          } else {
            alert("Payment verification failed");
          }*/
        },
        modal: {
          ondismiss: function () {
            alert("Payment cancelled");
          }
        },
        theme: {
          color: "#4D7B2B"
        }
      };

      // 3. Open Razorpay
      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    }
  };

  if (loading)
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  if (!cart) return <Typography>Cart not found.</Typography>;



  return (
        <>
      <Header />
    <Box p={4} bgcolor="#f9fafc" minHeight="100vh">
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        
         {t("payment_checkout" , "Payment Checkout")}
      </Typography>

      <Grid container spacing={4}>
        {/* LEFT COLUMN */}
        <Grid item xs={12} md={7}>
          {/* Order Summary */}
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                 {t("order_summary" , "Order Summary")} 
              </Typography>
              {cart.cartItems.map((item, i) => (
                <Box key={i} display="flex" justifyContent="space-between" mb={1}>
                  <Typography variant="body1">
                      {t(normalizeKey(item.productName) , item.productName)} /
                   
                    {t(normalizeKey(item.productVariantName) , item.productVariantName)} - {item.size} (x{item.quantity})
                     </Typography>
                  <Typography variant="body3"  color="error">- ₹{item.discountAtTimeOfAdd}</Typography>
                  <Typography variant="body1">₹{item.priceAtTimeOfAdd * item.quantity}</Typography>
                 
                </Box>
              ))}

            </CardContent>
          </Card>

          {/* Shipping Address */}
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                
                 {t("shipping_address" , "Shipping Address")}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {cart.shippingAddress.street1} {cart.shippingAddress.street2} {cart.shippingAddress.city}
               {cart.shippingAddress.state}, {cart.shippingAddress.country} - {cart.shippingAddress.postalCode}
              </Typography>
            {/*  <Button
                variant="outlined"
                size="small"
                sx={{ mt: 2 }}
                onClick={onChangeAddress}
              >
                Change Address
              </Button> */}
            </CardContent>
          </Card>

          {/* Coupon */}
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {t("apply_coupon" , "Apply Coupon")}
              </Typography>
              <Box display="flex" gap={2}>
                <TextField
                  label="Enter Coupon"
                  size="small"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                  fullWidth
                />
                <Button variant="contained" onClick={handleApplyCoupon}>
                  {t("apply" , "Apply")}
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* RIGHT COLUMN */}
        <Grid item xs={12} md={5}>
    

          {/* Price Details */}
          <Card> 
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Price Details
              </Typography>
              <Box display="flex" justifyContent="space-between" mb={1}>
                <Typography> {t("subtotal" , "Subtotal")}:</Typography>
                <Typography>₹{cart.totalAmount}</Typography>
              </Box>
              <Typography variant="subtitle1" color="text.secondary">
                {t("discount_total" , "Discount Total")}: ₹{cart.discountTotal}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                {t("coupon_total" , "Coupon Total")}: ₹{cart.couponTotal}
              </Typography>
              <Box display="flex" justifyContent="space-between" mb={1}>
                <Typography>{t("tax" , "Tax")}:</Typography>
                <Typography>₹{cart.taxAmount}</Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" mb={1}>
                <Typography> {t("shipping" , "Shipping")}:</Typography>
                <Typography>₹{cart.shippingCost}</Typography>
              </Box>
              
              {(cart.discountTotal > 0 || cart.couponTotal )  && (
                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography color="success.main"> Discount:</Typography>
                  <Typography color="success.main">- ₹{cart.discountTotal + cart.couponTotal }</Typography>
                </Box>
              )}
              
              <Divider sx={{ my: 2 }} />
              <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography variant="h6" fontWeight="bold">
                  {t("total_payable" , "Total Payable")}:
                </Typography>
                <Typography variant="h6" fontWeight="bold" color="success.main">
                  ₹{cart.grandTotal}
                </Typography>
              </Box>
              <Button
                variant="contained"
                color="success"
                fullWidth
                size="large"
                onClick={handlePay}
              >
                {t("pay" , "Pay")} ₹{cart.grandTotal}
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
      <Footer />
    </>
  );
};

export default Payment;


